import {OpenPopupData} from '../../../../../../micromate-learn-web/src/app/core/OpenPopupData';
import {InsightPopupTabs} from './InsightPopupTabs';

export const INSIGHT_POPUP_NAME = 'InsightPopup';

export class OpenInsightPopupData implements OpenPopupData {
    public popupName: string = INSIGHT_POPUP_NAME;
    public data: { learningPackageName: string, insightPopupPage: InsightPopupTabs };

    constructor(public learningPackageName: string, public insightPopupPage: InsightPopupTabs = InsightPopupTabs.DETAILS) {
        this.data = {learningPackageName: learningPackageName, insightPopupPage: insightPopupPage};
    }

}
